import { useState } from 'react';

import {
  Button,
  ButtonCallNotes,
  ButtonGoBack,
  SelectableItem,
} from '../../Shared';

export const WhatHappened = ({
  setIndex,
  setHappenedIndex,
  happenedIndex,
  handleFinishCall,
  handleOpen3,
  formCallNotes,
  resetPitchState,
  isDialOutcomesLoading,
  hasPhoneNumberToSave,
  handleOpenUnsavedNumberModal,
}) => {
  const [happenedContent, setHappenedContent] = useState('');

  return (
    <>
      <div className="h-[386px] overflow-y-auto overflow-x-hidden rounded-[20px] bg-white/30 p-6 [&::-webkit-scrollbar-thumb]:bg-secondary/80 [&::-webkit-scrollbar-track]:bg-secondary/20 [&::-webkit-scrollbar]:w-2">
        <p className="text-brand-900 text-center font-semibold text-[18px]/[24px]">
          What happened on your call?
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <SelectableItem
            label="Booked an appointment"
            onClick={() => {
              setIndex(2);
              setHappenedIndex(0);
              resetPitchState(true);
            }}
            variant="primary"
          />
          <SelectableItem
            label="Scheduled a callback"
            onClick={() => {
              setIndex(2);
              setHappenedIndex(1);
              resetPitchState(true);
            }}
            variant="primary"
          />
          <SelectableItem
            label="Send an email"
            onClick={() => {
              setIndex(7);
              setHappenedIndex(2);
              resetPitchState(true);
            }}
            variant="primary"
          />
        </div>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <SelectableItem
            label="Hung up"
            selected={happenedContent === 'Hung up'}
            onClick={() => {
              setHappenedContent('Hung up');
              setHappenedIndex(4);
            }}
            variant="secondary"
          />
          <SelectableItem
            label="Not interested"
            onClick={() => {
              setIndex(16);
              setHappenedIndex(5);
              resetPitchState(true);
            }}
            variant="secondary"
          />
        </div>
        <div className="mt-3 flex flex-wrap items-center justify-center gap-3">
          <SelectableItem
            label="No answer"
            selected={happenedContent === 'No answer'}
            onClick={() => {
              setHappenedContent('No answer');
              setHappenedIndex(6);
            }}
            variant="secondary"
          />
          <SelectableItem
            label="Do Not Call"
            onClick={() => {
              setIndex(18);
              setHappenedIndex(8);
              resetPitchState(true);
            }}
            variant="secondary"
          />
        </div>
      </div>
      <div className="flex items-center justify-between rounded-[20px] bg-white/30 px-6 py-5">
        <ButtonGoBack
          onClick={() => {
            hasPhoneNumberToSave ? handleOpenUnsavedNumberModal() : setIndex(0);
          }}
          disabled={isDialOutcomesLoading}
        />
        {(happenedIndex === 4 || happenedIndex === 6) && (
          <Button
            title="Finish"
            onClick={handleFinishCall}
            disabled={isDialOutcomesLoading}
          />
        )}
        <ButtonCallNotes
          onClick={handleOpen3}
          hasBg={formCallNotes && formCallNotes !== 'null'}
          disabled={isDialOutcomesLoading}
        />
      </div>
    </>
  );
};
